export const LIST_INSPECTION =`
  query LIST_INSPECTION($limit: Int) {
    listInspections(limit: $limit) {
      items {
        id
        inspectionType
        inspectionStatus
        startAt
        inspector {
          id
          name
        }
        vehicle {
          id
          customerVehicleId
          customer {
            id
          }
        }
        nextInspectionDue
        inspectionObservations
        inspectionDefects {
          defectType
          defectDesc
          redTag
        }
      }
    }
  }
`;


export const getCustomer = `query GetCustomer($id: ID!) {
  getCustomer(id: $id) {
    id
    calbitCustomerID
    companyName
    vehicles {
      items {
        id
        customerVehicleId
        inspections {
          items {
            id
            inspectionType
            inspectionStatus
            startAt
            endAt
            nextInspectionDue
            inspectionObservations
            vehicle{
              id
              customerVehicleId
            }
          }
          
          nextToken
        }
       
      }
      nextToken
    }
    generalInstructions
  }
}
`;

export const getCustomerVehicle = `query GetCustomer($id: ID!) {
  getCustomer(id: $id) {
    id
    calbitCustomerID
    companyName
    vehicles {
      items {
        id
        customerVehicleId
        vehicleYear
        make
        customer {
          id
        }
        
      }
      nextToken
    }
    generalInstructions
  }
}
`;


export const LIST_VEHICALS_INSPECTIONS=`
  query ListVehicles(
    $limit: Int
    $nextToken: String
  ){
    listVehicles(limit:$limit,nextToken:$nextToken){
      items{
        id
        customerVehicleId
        inspections{
          items{
            id
            inspectionType
            inspectionStatus
            startAt
            endAt
            nextInspectionDue
            inspectionObservations
            vehicle{
              id
              customerVehicleId
            }
          }
        }
      }
    }   
  }
`

export const LIST_INSPECTORS = `
  query ListInspectors(
    $filter: ModelInspectorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInspectors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        homeAddress
        city
        state
        phoneNo
        email
        overAllRating
        inspectingSince
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        qualifications {
          title
          dateAchieved
        }
        skills
        experienceInYears
        employmentHistory {
          jobTitle
          company
          startDate
          endDate
          currentlyWorking
          description
        }
        authorizedVehTypes
      }
      nextToken
    }
  }
`;

export const getVehicles= `query ListVehicles(
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  listVehicles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      customerVehicleId
    }
    nextToken
  }
}
`;
export const listVehicles = `query ListVehicles(
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  listVehicles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      customerVehicleId
      inspections {
        nextToken
      }
      customer {
        id
        calbitCustomerID
        customerFirstName
        customerLastName
        email
      }
      make
      model
      VIN
      vehicleYear
      license
      notes
      vehicleType {
        id
        vehicleType
      }
    }
    nextToken
  }
}
`;

export const listCustomers = `query ListCustomers(
  $filter: ModelCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      calbitCustomerID
      companyName
    }
    nextToken
  }
}
`;


// WEBPACK FOOTER //
// ./src/config/myqueries.js